interface ProjectItem {
	title: string
	link?: string
	thumbnail?: {
		childImageSharp: {
			fixed: {
				src: string
				srcSet: string
				srcSetWebp: string
				width: number
				height: number
			}
		}
	}
	theme?: "light" | "blue" | "black"
	color?: string
	banner?: string
	textColor?: string
	backgroundSize?: string
	rightBlockStyle?: string
	buttonColor?: "orange" | "blue" | "white" | "black"
	leftBlockStyle?: string
}

const projectsList: ProjectItem[] = [
	{
		title: "projects-new.list.ai.title",
		link: "ai-sales",
		theme: "light",
		color: "#f9f9f9",
		banner: "/images/projects-cards/ai-sales.png",
		textColor: "#050D71",
	},
	{
		title: "projects-new.list.geopop.title",
		link: "geopop",
		theme: "light",
		color: "#f9f9f9",
		banner: "/images/projects-cards/geopop-project.png",
		textColor: "#050D71",
	},
	{
		title: "projects-new.list.nexus.title",
		link: "nexus-mentis",
		theme: "light",
		color: "#f9f9f9",
		banner: "/images/projects-cards/nexus-mentis.png",
		textColor: "#050D71",
	},
	{
		title: "projects-new.list.ba.title",
		link: "brand-affinity",
		theme: "light",
		color: "#f9f9f9",
		banner: "/images/projects-cards/brand-affinity-preview.png",
		textColor: "#050D71",
	},
	{
		title: "projects-new.list.b2.title",
		link: "b2-connect",
		theme: "light",
		color: "#f9f9f9",
		banner: "/images/projects-cards/b2-connect.png",
		textColor: "#050D71",
	},
	{
		title: "projects-new.list.convidi.title",
		link: "convidi",
		theme: "light",
		color: "#f9f9f9",
		banner: "/images/projects-cards/convidi.png",
		textColor: "#050D71",
	},
	{
		title: "projects-new.list.telecom.title",
		link: "maxima-telecom",
		theme: "light",
		color: "#f9f9f9",
		banner: "/images/projects-cards/maxima-telecom.png",
		textColor: "#050D71",
	},
	{
		title: "projects-new.list.lm.title",
		link: "loyalty-manager",
		theme: "light",
		color: "#f9f9f9",
		banner: "/images/projects-cards/loyalty-manager-banner.png",
		textColor: "#050D71",
	},
	{
		title: "projects-new.list.ds.title",
		link: "backlite-media",
		theme: "light",
		color: "#2cd5c4",
		banner: "/images/projects-cards/backlite-media-m.png",
	},
	{
		title: "projects-new.list.mosaic.title",
		link: "mosaic",
		theme: "light",
		color: "linear-gradient(180deg, #f76425 0%, #ff2e00 100%)",
		banner: "/images/projects-cards/mosaic.png",
	},
	{
		title: "projects-new.list.sportex.title",
		link: "sportex",
		theme: "black",
		color: "#f9f9f9",
		banner: "/images/projects-cards/sportex.png",
		textColor: "#050D71",
	},
	{
		title: "projects-new.list.stylist.title",
		link: "your-stylist",
		theme: "blue",
		color: "#eef8f9",
		textColor: "#006b89",
		banner: "/images/projects-cards/your-stylist.png",
	},
	{
		title: "projects-new.list.video.title",
		link: "video-sift",
		theme: "black",
		color: "linear-gradient(to left, #fbf8f82e 52%, #fffefe8c 74%)",
		banner: "/images/projects-cards/video-sift.png",
		textColor: "#212121",
	},

	{
		title: "projects-new.list.mt.title",
		link: "movie-teller",
		theme: "light",
		color: "#212121",
		banner: "/images/projects-cards/movie-teller.png",
	},
]

export function findIndex(url) {
	let indexProject = 0
	projectsList.forEach(({ link }, i) => {
		if (link === url) {
			indexProject = i
		}
	})
	return indexProject
}

export { projectsList, ProjectItem }
